import { onMounted, onUnmounted, ref } from "vue";

// iOS Safari resizes the visual viewport (not the layout viewport) when the
// on-screen keyboard opens, so `position: fixed; bottom: 0` elements stay
// pinned below the keyboard instead of above it. Track the gap and let
// callers offset a fixed element by it.
export function useKeyboardInset() {
  const inset = ref(0);

  function update() {
    const vv = window.visualViewport;
    if (!vv) return;
    inset.value = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
  }

  onMounted(() => {
    window.visualViewport?.addEventListener("resize", update);
    window.visualViewport?.addEventListener("scroll", update);
    update();
  });

  onUnmounted(() => {
    window.visualViewport?.removeEventListener("resize", update);
    window.visualViewport?.removeEventListener("scroll", update);
  });

  return inset;
}
